/* Bunion Fix Hebrew funnel: replaces the Funnelish runtime (FAQ, sticky bars, lazy videos, CTA param carry, date) + order popup. */
(function () {
  'use strict';
  var d = document;

  /* keep ad click params (utm_*, fbclid...) when moving from the story page to the sales page */
  d.querySelectorAll('a[data-bn-carry]').forEach(function (a) {
    if (!location.search) return;
    var u = new URL(a.getAttribute('href'), location.origin);
    new URLSearchParams(location.search).forEach(function (v, k) { if (!u.searchParams.has(k)) u.searchParams.set(k, v); });
    a.setAttribute('href', u.pathname + u.search);
  });

  /* FAQ accordion */
  d.querySelectorAll('.faq .faq-header').forEach(function (h) {
    h.addEventListener('click', function () { h.parentElement.classList.toggle('active'); });
  });

  /* sticky CTA bars that appear after N px of scroll */
  var sticky = d.querySelectorAll('.sticky_show_after');
  if (sticky.length) {
    var onScroll = function () {
      sticky.forEach(function (el) {
        var t = +(el.dataset.show_after || 0);
        el.classList.toggle('visible', window.scrollY > t);
      });
    };
    window.addEventListener('scroll', onScroll, { passive: true }); onScroll();
  }

  /* muted looping videos: attach the source only when near the viewport */
  var vids = d.querySelectorAll('video[data-bn-src]');
  var startVideo = function (v) {
    if (v.src) return;
    v.muted = true; v.src = v.getAttribute('data-bn-src');
    var p = v.play(); if (p && p.catch) p.catch(function () {});
  };
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { startVideo(e.target); io.unobserve(e.target); } });
    }, { rootMargin: '600px 0px' });
    vids.forEach(function (v) { io.observe(v); });
  } else vids.forEach(startVideo);

  /* advertorial date = today, in Hebrew */
  d.querySelectorAll('[data-bn-date]').forEach(function (el) {
    var now = new Date();
    var date = now.toLocaleDateString('he-IL', { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' });
    var time = now.toLocaleTimeString('he-IL', { hour: '2-digit', minute: '2-digit' });
    el.textContent = date + ' | ' + time + ' | 251,328 צפיות 👁';
  });

  /* lander: the facts line inside the sticky buy bar (snippets/bn-lander-facts.liquid) stays with the button
     for the whole page (owner's request, 2026-09-30), so no script touches it. */

  /* ---------------- order popup ---------------- */
  var pop = d.getElementById('bn-order');
  if (!pop) return;
  var form = pop.querySelector('[data-bno-form]');
  var go = pop.querySelector('[data-bno-go]');
  var label = go.querySelector('[data-bno-label]');
  var total = pop.querySelector('[data-bno-total]');
  var totalLine = total && total.parentNode;
  var promoEl = pop.querySelector('[data-bno-promo]');
  var err = pop.querySelector('[data-bno-err]');
  var lastFocus = null;
  var busy = false; /* true from the pay tap until the page leaves, or the add fails */

  function store(k, v) { try { if (v === undefined) return sessionStorage.getItem(k); sessionStorage.setItem(k, v); } catch (e) { return null; } }

  /* sign-up code: after a popup sign-up, checkout applies BUNION20 by itself (₪20 off). The popup
     (assets/st-popup.js) leaves sessionStorage stp_code, and may fire window 'stp:code' with {code, amount},
     amount in shekels. Kept in memory as well, so it still works when sessionStorage is blocked. */
  var promo = null; /* { code, cents } */
  function readPromo() { if (!promo && store('stp_code') === 'BUNION20') promo = { code: 'BUNION20', cents: 2000 }; }
  window.addEventListener('stp:code', function (e) {
    var dt = (e && e.detail) || {}, amount = +dt.amount;
    if (!dt.code) return;
    if (!(amount > 0) && String(dt.code) === 'BUNION20') amount = 20;
    if (!(amount > 0)) return;
    promo = { code: String(dt.code), cents: Math.round(amount * 100) };
    sync();
  });

  /* highlight the chosen pack and, unless we are on the way to checkout, show its discount on the button
     ("להמשך לתשלום | 63% הנחה": data-label on the button, data-off on each pack, the same number as the
     pack's badge) and its total under the button ("סה״כ לתשלום: ₪219.90": data-price on each pack) */
  function sync() {
    form.querySelectorAll('.bno__tier').forEach(function (l) { l.classList.toggle('is-sel', l.querySelector('input').checked); });
    if (busy) return;
    var input = form.querySelector('input:checked');
    var off = input ? +input.getAttribute('data-off') : 0;
    label.textContent = off > 0 ? go.getAttribute('data-label').replace('{off}', off) : go.getAttribute('data-label-plain');
    if (!total) return;
    /* total under the button; after a sign-up, the price after the code: "₪199.90 (כולל 20 ₪ הנחה עם הקוד BUNION20)" */
    var price = (input && input.getAttribute('data-price')) || '';
    var cents = input ? +input.getAttribute('data-cents') : 0;
    if (promo && promoEl && cents > promo.cents) {
      total.textContent = price.replace(/[0-9.,]+/, ((cents - promo.cents) / 100).toFixed(2));
      promoEl.textContent = totalLine.getAttribute('data-promo').replace('{amount}', promo.cents / 100).replace('{code}', promo.code);
      promoEl.hidden = false;
    } else {
      total.textContent = price;
      if (promoEl) promoEl.hidden = true;
    }
  }

  /* ready state: button on, its label back, no error. Runs at start-up, when the box opens (unless a checkout
     request is still running), when Back brings the page back from the back-forward cache (pageshow with
     persisted; a normal load also fires pageshow, which must not reset a running request), and after a
     failed add. */
  function ready() {
    busy = false; go.disabled = false; go.classList.remove('is-busy'); err.hidden = true;
    sync();
  }

  function open(e) {
    if (e) e.preventDefault();
    lastFocus = d.activeElement;
    pop.hidden = false; d.body.classList.add('bno-open');
    store('bno_opened', '1'); /* read by the signup popup (snippets/st-bunion-popup.liquid): stay away from this visitor */
    readPromo();
    if (!busy) ready();
    var sel = pop.querySelector('.bno__tier.is-sel input') || pop.querySelector('.bno__tier input');
    if (sel) sel.focus({ preventScroll: true });
    /* a ?variant link (cart reminder emails) can preselect a pack that sits under the footer on a short phone:
       scroll the pack list just enough to show the chosen card */
    var list = pop.querySelector('.bno__body'), card = sel && sel.closest('.bno__tier');
    if (list && card) { var over = card.getBoundingClientRect().bottom - list.getBoundingClientRect().bottom; if (over > 0) list.scrollTop += over + 12; }
  }
  function close() {
    pop.hidden = true; d.body.classList.remove('bno-open');
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }

  d.addEventListener('click', function (e) {
    var t = e.target.closest('[data-bn-order], a[href="#order"]');
    if (t) return open(e);
    if (e.target.closest('[data-bno-close]')) close();
  });
  d.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !pop.hidden) close(); });
  window.addEventListener('pageshow', function (e) { if (e.persisted) { readPromo(); ready(); } });
  readPromo();
  ready();
  /* a link with #order (the story page's sign-up popup, "להזמנה עכשיו") opens the box on arrival. open() also leaves
     bno_opened, so the lander's sign-up popup stays away. Then the hash leaves the address, so a reload or a shared
     link does not open the box again. */
  if (location.hash === '#order') {
    open();
    try { history.replaceState(history.state, '', location.pathname + location.search); } catch (e) {}
  }

  form.addEventListener('change', sync);

  go.addEventListener('click', function () {
    var input = form.querySelector('input:checked');
    if (busy || !input) return;
    busy = true; go.disabled = true; go.classList.add('is-busy'); err.hidden = true;
    label.textContent = go.getAttribute('data-label-busy');
    store('bno_checkout', '1'); /* read by the signup popup: this visitor went on to checkout */
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    /* line item property with the pack's discount: checkout ignores "was" prices, but it shows a property whose key
       does not start with "_" under the product, so the visitor still sees "המבצע: 63% הנחה - כבר כלולה במחיר" */
    var off = parseInt(input.getAttribute('data-off'), 10);
    var item = { id: +input.value, quantity: 1 };
    if (off > 0) item.properties = { 'המבצע': off + '% הנחה - כבר כלולה במחיר' };
    fetch(root + 'cart/clear.js', { method: 'POST', headers: { 'Content-Type': 'application/json' } })
      .then(function () {
        return fetch(root + 'cart/add.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [item] })
        });
      })
      .then(function (r) { if (!r.ok) throw new Error('add ' + r.status); return r.json(); })
      .then(function () { window.location.href = root + 'checkout'; })
      .catch(function () { ready(); err.hidden = false; });
  });
})();
